import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import RoutePublic from 'components/Route/Public/Public';
import ScreensUserLogin from './Login/ScreensUserLogin';
import ScreensUserProfile from './Profile/ScreensUserProfile';
import ScreensAccessAgreement from './AccessAgreement/ScreensAccessAgreement';
import ScreensUserChangePassword from './ChangePassword/ScreensUserChangePassword';
import ScreensUserChangePasswordDone from './ChangePassword/Done/ScreensUserChangePasswordDone';
import ScreensUserResetPassword from './ResetPassword/ScreensUserResetPassword';
import ScreensUserAccessDenied from './AccessDenied/ScreensUserAccessDenied';
import ScreensUserShowcaseOnlyAccess from './ShowcaseOnlyAccess/ScreensUserShowcaseOnlyAccess';

function ScreensUsersGetLocation() {
  return '/';
}

function ScreensUserResetPasswordGetLocation() {
  return '/reset-password';
}

function ScreensUser() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <RoutePublic
            element={ScreensUserLogin}
            getLocation={ScreensUsersGetLocation}
            externalContext={false}
          />
        }
      />
      <Route
        path="/reset-password"
        element={
          <RoutePublic
            element={ScreensUserResetPassword}
            getLocation={ScreensUserResetPasswordGetLocation}
            externalContext={false}
          />
        }
      />
      <Route
        path="/profile"
        element={<RoutePrivate element={ScreensUserProfile} />}
      />
      <Route
        path="/account-access-agreement"
        element={<RoutePrivate element={ScreensAccessAgreement} />}
      />
      <Route
        path="/change-password/done"
        element={<RoutePrivate element={ScreensUserChangePasswordDone} />}
      />
      <Route
        path="/change-password"
        element={<RoutePrivate element={ScreensUserChangePassword} />}
      />
      <Route path="/access-denied" element={<ScreensUserAccessDenied />} />
      <Route
        path="/showcase-only-access"
        element={<ScreensUserShowcaseOnlyAccess />}
      />
      <Route path="/" element={<Navigate replace to="/404" />} />
    </Routes>
  );
}

export default ScreensUser;
